import { type ViewRemoveInput, type ViewRemoveSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useViewCache } from './cache'

export function useRemoveView(): RemoveHookResponse<ViewRemoveInput> {
  const cache = useViewCache()
  const mutation = useTantalimMutation<ViewRemoveInput, ViewRemoveSuccess>({ url: '/view/remove' })

  async function remove(input: ViewRemoveInput): Promise<void> {
    await mutation.mutateAsync(input)
    await cache.remove(input.viewId)
  }

  return mutationRemove(mutation, remove)
}
